import type { MessageRenderer, RendererConfig, RendererResult, AnimationState } from './types';

/**
 * Renderer that displays content with fade-in effect
 */
export class FadeInRenderer implements MessageRenderer {
  render(
    _messageId: string,
    config: RendererConfig,
    currentState: AnimationState
  ): RendererResult {
    const opacity = currentState.fadeOpacity ?? 0;

    return {
      displayContent: config.content,
      isComplete: opacity >= 1,
    };
  }

  getInitialState(): AnimationState {
    return { fadeOpacity: 0 };
  }
}

